import React, { useState, useEffect } from 'react';
import { ExpandMore, ExpandLess } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import {
  Popover,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
} from '@material-ui/core';

const useStyles = makeStyles({
  icon: {
    minWidth: 30,
  },
  wrapper: {
    display: 'flex',
  },
  mainMonthButton: {
    padding: '8px 0 0 24px',
    color: '#484848',
  },
  button: {
    padding: '8px 0 8px 24px',
    color: '#484848',
    fontSize: 16,
  },
  monthButton: {
    padding: '0 0 0 24px',
    color: '#484848',
    fontSize: 14,
  },
  month: {
    fontWeight: 'bold',
    margin: '0 10px 0 0',
  },
  list: {
    minWidth: 208,
    maxHeight: 400,
  },
  subWrapper: {
    display: 'flex',
  },
  apply: {
    margin: '0 50px 0 0',
    color: '#10587f',
    fontWeight: 'bold',
    fontSize: 12,
    cursor: 'pointer',
    backgroundColor: 'transparent',
    WebkitTapHighlightColor: 'transparent',
    outlineColor: 'transparent',
    border: 'none',
  },
  clean: {
    margin: 0,
    color: '#10587f',
    fontSize: 12,
    cursor: 'pointer',
  },
  bigText: {
    color: '#013957',
    fontSize: 16,
    '& span': {
      fontWeight: 'bold',
    },
  },
  text: {
    color: '#013957',
    fontSize: 14,
    '& span': {
      fontWeight: 'bold',
    },
  },
});

function FilterDropdown({
  id,
  open,
  anchorEl,
  onClose,
  anchorOrigin,
  transformOrigin,
  handleOption,
  option,
  handleSubItemsList,
}) {
  const classes = useStyles();
  const [openCollapse, setOpenCollapse] = useState(false);
  const handleCollapse = () => {
    setOpenCollapse(!openCollapse);
  };
  //const [ option, setOption ] = useState("")

  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={anchorOrigin && anchorOrigin}
      transformOrigin={transformOrigin && transformOrigin}
    >
      <List
        component="nav"
        aria-labelledby="nested-list-subheader"
        className={classes.list}
      >
        <ListItem
          button
          className={classes.button}
          name="todas"
          onClick={(e) => {
            //setOption("Todas");
            handleOption(e, 'all');
          }}
        >
          {option && option === 'all' ? (
            <>
              <ListItemIcon classes={{ root: classes.icon }}>
                <img src="/img/tick.svg" alt="tick" />
              </ListItemIcon>
              <ListItemText
                primary="Todas"
                classes={{ root: classes.bigText }}
              />
            </>
          ) : (
            <ListItemText primary="Todas" />
          )}
        </ListItem>
        {/* <ListItem
          button
          className={classes.button}
          onClick={(e) => {
            //setOption("Hoy");
            handleOption(e, 'today');
          }}
        >
          {option && option === 'today' ? (
            <>
              <ListItemIcon classes={{ root: classes.icon }}>
                <img src="/img/tick.svg" alt="tick" />
              </ListItemIcon>
              <ListItemText primary="Hoy" classes={{ root: classes.bigText }} />
            </>
          ) : (
            <ListItemText primary="Hoy" />
          )}
        </ListItem> */}
        <ListItem
          button
          className={classes.button}
          onClick={(e) => {
            //setOption("Semana");
            handleOption(e, 'week');
          }}
        >
          {option && option === 'week' ? (
            <>
              <ListItemIcon classes={{ root: classes.icon }}>
                <img src="/img/tick.svg" alt="tick" />
              </ListItemIcon>
              <ListItemText
                primary="Semana"
                classes={{ root: classes.bigText }}
              />
            </>
          ) : (
            <ListItemText primary="Semana" />
          )}
        </ListItem>
        <ListItem
          button
          onClick={handleCollapse}
          className={classes.mainMonthButton}
        >
          <ListItemText
            primary={
              <div className={classes.wrapper}>
                <div className={classes.month}>Mes</div>
                {openCollapse ? <ExpandLess /> : <ExpandMore />}
              </div>
            }
          />
        </ListItem>
        <Collapse in={openCollapse} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem
              button
              className={classes.monthButton}
              onClick={(e) => {
                //setOption("Enero");
                handleOption(e, 1);
              }}
            >
              {option && (option === 1)? (
                <>
                  <ListItemIcon classes={{ root: classes.icon }}>
                    <img src="/img/tick.svg" alt="tick" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Enero"
                    classes={{ root: classes.text }}
                  />
                </>
              ) : (
                <ListItemText primary="Enero" />
              )}
            </ListItem>
            <ListItem
              button
              className={classes.monthButton}
              onClick={(e) => {
                //setOption("Febrero");
                handleOption(e, 2);
              }}
            >
              {option && option === 2 ? (
                <>
                  <ListItemIcon classes={{ root: classes.icon }}>
                    <img src="/img/tick.svg" alt="tick" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Febrero"
                    classes={{ root: classes.text }}
                  />
                </>
              ) : (
                <ListItemText primary="Febrero" />
              )}
            </ListItem>
            <ListItem
              button
              className={classes.monthButton}
              onClick={(e) => {
                //setOption("Marzo");
                handleOption(e, 3);
              }}
            >
              {option && option === 3 ? (
                <>
                  <ListItemIcon classes={{ root: classes.icon }}>
                    <img src="/img/tick.svg" alt="tick" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Marzo"
                    classes={{ root: classes.text }}
                  />
                </>
              ) : (
                <ListItemText primary="Marzo" />
              )}
            </ListItem>
            <ListItem
              button
              className={classes.monthButton}
              onClick={(e) => {
                //setOption("Abril");
                handleOption(e, 4);
              }}
            >
              {option && option === 4 ? (
                <>
                  <ListItemIcon classes={{ root: classes.icon }}>
                    <img src="/img/tick.svg" alt="tick" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Abril"
                    classes={{ root: classes.text }}
                  />
                </>
              ) : (
                <ListItemText primary="Abril" />
              )}
            </ListItem>
            <ListItem
              button
              className={classes.monthButton}
              onClick={(e) => {
                //setOption("Mayo");
                handleOption(e, 5);
              }}
            >
              {option && option === 5 ? (
                <>
                  <ListItemIcon classes={{ root: classes.icon }}>
                    <img src="/img/tick.svg" alt="tick" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Mayo"
                    classes={{ root: classes.text }}
                  />
                </>
              ) : (
                <ListItemText primary="Mayo" />
              )}
            </ListItem>
            <ListItem
              button
              className={classes.monthButton}
              onClick={(e) => {
                //setOption("Junio");
                handleOption(e, 6);
              }}
            >
              {option && option === 6 ? (
                <>
                  <ListItemIcon classes={{ root: classes.icon }}>
                    <img src="/img/tick.svg" alt="tick" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Junio"
                    classes={{ root: classes.text }}
                  />
                </>
              ) : (
                <ListItemText primary="Junio" />
              )}
            </ListItem>
            <ListItem
              button
              className={classes.monthButton}
              onClick={(e) => {
                //setOption("Julio");
                handleOption(e, 7);
              }}
            >
              {option && option === 7 ? (
                <>
                  <ListItemIcon classes={{ root: classes.icon }}>
                    <img src="/img/tick.svg" alt="tick" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Julio"
                    classes={{ root: classes.text }}
                  />
                </>
              ) : (
                <ListItemText primary="Julio" />
              )}
            </ListItem>
            <ListItem
              button
              className={classes.monthButton}
              onClick={(e) => {
                //setOption("Agosto");
                handleOption(e, 8);
              }}
            >
              {option && option === 8 ? (
                <>
                  <ListItemIcon classes={{ root: classes.icon }}>
                    <img src="/img/tick.svg" alt="tick" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Agosto"
                    classes={{ root: classes.text }}
                  />
                </>
              ) : (
                <ListItemText primary="Agosto" />
              )}
            </ListItem>
            <ListItem
              button
              className={classes.monthButton}
              onClick={(e) => {
                //setOption("Septiembre");
                handleOption(e, 9);
              }}
            >
              {option && option === 9 ? (
                <>
                  <ListItemIcon classes={{ root: classes.icon }}>
                    <img src="/img/tick.svg" alt="tick" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Septiembre"
                    classes={{ root: classes.text }}
                  />
                </>
              ) : (
                <ListItemText primary="Septiembre" />
              )}
            </ListItem>
            <ListItem
              button
              className={classes.monthButton}
              onClick={(e) => {
                //setOption("Octubre");
                handleOption(e, 10);
              }}
            >
              {option && option === 10 ? (
                <>
                  <ListItemIcon classes={{ root: classes.icon }}>
                    <img src="/img/tick.svg" alt="tick" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Octubre"
                    classes={{ root: classes.text }}
                  />
                </>
              ) : (
                <ListItemText primary="Octubre" />
              )}
            </ListItem>
            <ListItem
              button
              className={classes.monthButton}
              onClick={(e) => {
                //setOption("Noviembre");
                handleOption(e, 11);
              }}
            >
              {option && option === 11 ? (
                <>
                  <ListItemIcon classes={{ root: classes.icon }}>
                    <img src="/img/tick.svg" alt="tick" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Noviembre"
                    classes={{ root: classes.text }}
                  />
                </>
              ) : (
                <ListItemText primary="Noviembre" />
              )}
            </ListItem>
            <ListItem
              button
              className={classes.monthButton}
              onClick={(e) => {
                //setOption("Diciembre");
                handleOption(e, 12);
              }}
            >
              {option && option === 12 ? (
                <>
                  <ListItemIcon classes={{ root: classes.icon }}>
                    <img src="/img/tick.svg" alt="tick" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Diciembre"
                    classes={{ root: classes.text }}
                  />
                </>
              ) : (
                <ListItemText primary="Diciembre" />
              )}
            </ListItem>
          </List>
        </Collapse>
        
      </List>
    </Popover>
  );
}

export default FilterDropdown;
